import { Checkbox } from "primereact/checkbox";
import TextInput from "./TextInput";

import commonStyle from "../../content/CommonStyles.module.css";

const ActNumberWithAutogenerateInput = ({formik, showAutogenerate=true, isDisabled}) => {
    return (<>
        {showAutogenerate && <div className={commonStyle.checkBoxInput}>
            <div className={`${commonStyle.checkboxStyle} p-inputgroup flex-1"`}>
                <Checkbox
                    name="act_number_autogenerate"
                    onChange={(e) => { formik.setFieldValue('act_number_autogenerate', !formik.values.act_number_autogenerate) }}
                    checked={formik.values.act_number_autogenerate}
                />
                <label>Автоматично генерувати номер акту</label>
            </div>
        </div>}
        {!formik.values.act_number_autogenerate && <TextInput formik={formik} paramName={"act_number"} label={"Номер акту"} isDisabled={isDisabled}/>}
    </>);
}

export default ActNumberWithAutogenerateInput;